module.exports = __webpack_public_path__ + "static/media/cifar100_high_aum.cf8272e5.csv";